'use client';

import {
  FC,
  Children,
  isValidElement,
  cloneElement,
  useState,
  useCallback,
  ReactElement,
} from 'react';
import { getClasses } from '@/_utils/classnames';
import styles from './Accordion.module.css';
import type {
  AccordionProps,
  AccordionTitleProps,
  AccordionContentProps,
} from './Accordion.types';
import { AccordionTitle } from './_components/AccordionTitle';
import { AccordionContent } from './_components/AccordionContent';

export const Accordion: FC<AccordionProps> = ({
  children,
  isOpen: initialIsOpen,
  className,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(initialIsOpen ?? false);
  const toggleAccordion = useCallback(() => setIsOpen((prev) => !prev), []);

  return (
    <div className={getClasses(styles.accordion, className)}>
      {Children.map(children, (child) => {
        if (!isValidElement(child)) return child;

        if (child.type === AccordionTitle) {
          return cloneElement(child as ReactElement<AccordionTitleProps>, {
            onClick: toggleAccordion,
            isOpen,
          });
        }

        if (child.type === AccordionContent) {
          return cloneElement(child as ReactElement<AccordionContentProps>, {
            isOpen,
          });
        }

        return child;
      })}
    </div>
  );
};
